import { CSSProperties, PropsWithChildren, ReactNode, memo } from 'react';
import PageBreadcrumbs from 'src/shared/components/layout/PageBreadcrumbs';
import { cn } from 'src/shared/lib/utils';

type HeaderBarProps = {
  rightElement?: ReactNode;
  noBorder?: boolean;
  className?: string;
  progress?: number;
  fallbackBreadcrumb?: {
    label: string;
    href?: string;
  };
};

function PageHeaderBar({
  children,
  rightElement,
  noBorder,
  className,
  progress,
  fallbackBreadcrumb,
}: PropsWithChildren<HeaderBarProps>) {
  return (
    <div
      className={cn(
        'relative w-full bg-white p-5 overflow-hidden shrink-0 flex items-center',
        !noBorder && 'border-b',
        progress !== undefined && [
          'before:absolute before:bottom-0 before:left-0 before:right-0 before:h-1 before:bg-gray-100',
          'after:absolute after:bottom-0 after:left-0 after:h-1 after:bg-primary after:transition-all after:w-[var(--progress-width)]',
        ],
        className
      )}
      style={
        {
          gridArea: 'topBar',
          '--progress-width': progress !== undefined ? `${progress * 100}%` : '0%',
        } as CSSProperties
      }
    >
      {children ? children : <PageBreadcrumbs fallbackBreadcrumb={fallbackBreadcrumb} />}
      {rightElement && <div className="top-0 right-0 h-full ml-auto">{rightElement}</div>}
    </div>
  );
}

export default memo(PageHeaderBar);
